"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_rxk_1 = require("react-rxk");
const gridState_1 = require("../simpleGrid/gridState");
const filtros_1 = require("./filtros");
const busqueda_1 = require("./busqueda");
const filtrarOrdenar_1 = require("../simpleGrid/filtrarOrdenar");
const tableFiltro_1 = require("./tableFiltro");
const drillDowns_1 = require("../simpleGrid/drillDowns");
const keautils_1 = require("keautils");
const keautils_2 = require("keautils");
const csv_1 = require("../simpleGrid/csv");
const HOC_1 = require("../../HOC");
const createShallowSelector = keautils_1.createDeepSelector;
class GridControlled extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.items = (props) => props.items == undefined ? [] : props.items;
        /**Columnas originales. Note que estas columnas pueden venir sin key */
        this.originalColumns = (props) => props.columnas || [];
        /**Asigna los keys por default */
        this.columnSelector = keautils_1.createSelector(this.originalColumns, cols => cols.map(x => (Object.assign({}, x, { key: x.key || x.title }))));
        this.originalColumnMapSelector = keautils_1.createSelector(this.columnSelector, cols => keautils_2.arrayToMap(cols, x => "" + x.key, x => x));
        this.originalGridState = (props) => props.gridState;
        this.columnKeys = keautils_1.createSelector(this.columnSelector, x => x.map(y => y.key));
        this.gridState = keautils_1.createSelector(this.originalGridState, this.columnKeys, gridState_1.gridStateDefaultValues);
        this.drillDownSelector = createShallowSelector(this.gridState, x => x.drillDowns);
        this.effectiveColumnMap = createShallowSelector(this.originalColumnMapSelector, this.drillDownSelector, (cols, dds) => {
            console.log("Effective columns");
            return drillDowns_1.getEffectiveColumns(cols, dds);
        });
        this.mapping = keautils_1.createSelector(this.gridState, state => state.mapping);
        this.filtroOrdenColumnsSelector = keautils_1.createSelector(this.effectiveColumnMap, this.items, (cols, items) => {
            return keautils_2.mapObject(cols, value => filtrarOrdenar_1.gridColumnToFiltroOrdenColumn(items, value));
        });
        this.itemsFiltroData = keautils_1.createSelector(this.items, this.filtroOrdenColumnsSelector, (items, columnas) => {
            return filtrarOrdenar_1.getItemCellData(items, columnas);
        });
        /**Obtiene todas las columnas efectivas del grid en el orden original */
        this.effectiveColumns = keautils_1.createSelector(this.effectiveColumnMap, this.mapping, (map, mapping) => mapping.map(key => map[key]));
        /**Obtiene los titulos de todas las columnas efectivas en un objeto donde la clave es el key y el valor es el titulo*/
        this.columnNames = keautils_1.createSelector(this.effectiveColumnMap, cols => keautils_2.mapObject(cols, x => x.title));
        this.originalColumnCountSelector = keautils_1.createSelector(this.columnSelector, x => x.length);
        this.filtroColumnasSelector = keautils_1.createSelector(this.effectiveColumnMap, this.items, (columns, items) => keautils_2.mapObject(columns, val => filtros_1.gridColumnToFiltroColumn(items, val)));
        this.filtroColumnaValueSelector = keautils_1.createSelector(this.gridState, state => state.filtroOrden.columna);
        this.onGridStateChangeSelector = (props) => props.onGridStateChange;
        this.filtroColumnaOnChangeSelector = keautils_1.createSelector(this.onGridStateChangeSelector, this.gridState, (onGridStateChange, gridState) => columna => onGridStateChange(Object.assign({}, gridState, { filtroOrden: Object.assign({}, gridState.filtroOrden, { columna: columna }) })));
        this.handleExportarCSV = () => {
            csv_1.downloadCsv(this.items(this.props), this.gridState(this.props), this.effectiveColumnMap(this.props));
        };
    }
    render() {
        const props = this.props;
        const effectiveColumns = this.effectiveColumns(this.props);
        const originalColumnCount = this.originalColumnCountSelector(this.props);
        const filtros = React.createElement(filtros_1.FiltroListComponent, { columnas: this.filtroColumnasSelector(this.props), items: this.itemsFiltroData(props), value: this.filtroColumnaValueSelector(this.props), onChange: this.filtroColumnaOnChangeSelector(this.props) });
        const busqueda = React.createElement(busqueda_1.GridBusquedaComponent, { value: this.gridState(this.props), onChange: props.onGridStateChange, columnas: this.columnNames(this.props), onExpotar: this.handleExportarCSV });
        const grid = React.createElement(tableFiltro_1.GridTableFiltro, { effectiveColumns: this.effectiveColumnMap(props), getKey: props.getKey, gridState: this.gridState(this.props), items: this.itemsFiltroData(props), filtroOrdenColumnas: this.filtroOrdenColumnsSelector(props), onGridStateChange: props.onGridStateChange, sharedProps: props.sharedProps, loading: props.loading, overflow: props.overflow, puedeQuitarColumnas: !props.hideBusqueda });
        return (React.createElement("div", null,
            filtros,
            !props.hideBusqueda && busqueda,
            grid));
    }
}
exports.Grid2 = react_rxk_1.componentToRx(HOC_1.makeUncontrolledCookies("gridState", "onGridStateChange")(GridControlled), undefined, undefined, { loading: { loading: true } });



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/components/grid.js
// module id = 2222
// module chunks = 0